export const AES="on"
export const key = "12345678909876541234567890987654";
export const iv = "1234567890987654";